// @flow

const matches = (currentPath: string, ...paths: string[]) => {
  return paths.indexOf(currentPath) > -1
}

export { matches }



// WEBPACK FOOTER //
// ./src/lib/matches.js